import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

export const OrderFileItem = ({ file }) => {
    return (
        <li key={file.id} className="flex flex-wrap items-center mb-2">
            <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="border rounded-[5px] relative group"
            >
                <FontAwesomeIcon icon={faFilePdf} className="block bg-slate-300 w-full py-3 rounded-t-[5px] text-white text-3xl text-center transition-all group-hover:bg-slate-200" />

                <div className="text-xs px-2 py-1">{file.url.split('/').pop()}</div>
                <div className="text-[11px] text-center text-gray-500 pb-2">{file.created_at}</div>
            </a>
        </li>
    );
};